import React, { useMemo } from 'react';
import useUser from 'src/contexts/docs/useUser';
import RateLimitTable, { type RateLimitRow } from '.';

interface Props {
  rows: RateLimitRow[];
  initialEnvironment?: 'production' | 'sandbox';
}

// Thin wrapper around the pure RateLimitTable that hides rows tagged with a
// `gating_flag` from visitors who lack the corresponding LD flag. The producer
// (scripts/filter-rate-limits.js) tags rows whose docs target is a flag-gated
// MDX page; this component evaluates the flag at render time so authorized
// users still see those rows in the table.
//
// Imported only by src/pages/docs/errors/rate-limit-exceeded.mdx — no barrel
// re-export. Other consumers wanting the same behavior should import this
// path explicitly.
const RateLimitTableWithFlagFilter = ({
  rows,
  initialEnvironment,
}: Props): React.ReactElement => {
  const { getFlagValue } = useUser();

  const visibleRows = useMemo(() => {
    return rows.filter((row) => {
      if (!row.gating_flag) return true;
      return getFlagValue(row.gating_flag) === true;
    });
  }, [rows, getFlagValue]);

  return (
    <RateLimitTable
      rows={visibleRows}
      initialEnvironment={initialEnvironment}
    />
  );
};

export default RateLimitTableWithFlagFilter;
